<template>
  <div class="overview-picture-container">
    <!--Fix for vuetour modal-->
    <div tabindex="-1" class="modal is-active custom-class custom-class-2" style="z-index:2000" v-if="$route.query.modal">
      <div class="modal-background"></div>
      <div class="animation-content" style="max-width: 700px;">
            <SheetBlockAssociatedDocumentsSelect  :type="docType" :mail="true"></SheetBlockAssociatedDocumentsSelect>
      </div>
    </div>

      <div class="overview-picture"
         :class="{'no-buttons' : hideDownload || docType === 'innovations', 'full-width': docType === 'innovations', 'loaded' : isLoadedPicture}">
      <img :src="`${picture}`" class="overview-image" alt="" @load="loadImage">
      <div class="radial-gradient" v-if="docType !== 'innovations'"></div>
      <div class="link-container" v-if="!hideDownload && docType !== 'innovations'"
           :class="{'has-ar-buttons': productDatas.experience !== undefined}">
        <router-link
            :to="btnRouteShowroom"
            class="button is-outlined is-rounded is-uppercase"
            :class="brandBackgroundColor"
            v-if="btnRouteShowroom && showButtonShowroom"
        >
          <span>{{ $t("showroom") }}</span>
          <span class="icon-arrow-right is-tiny is-right-side"></span>
        </router-link>
        <router-link
            :to="btnRouteDocuments"
            class="button is-outlined is-rounded is-uppercase"
            :class="brandBackgroundColor"
            v-if="showButtonDocuments && btnRouteDocuments"
        >
          <span>{{ $t("documents") }}</span>
          <span class="icon-arrow-right is-tiny is-right-side"></span>
        </router-link>

        <div class="buttons has-addons is-centered">

          <!--            <sheet-block-associated-documents-item-->
          <!--                class="button is-primary is-rounded is-uppercase mr-0"-->
          <!--                :class="brandBackgroundColor"-->
          <!--                :document="technicalNotice"-->
          <!--                :is-btn="true"-->
          <!--            >-->
          <!--              <span class="icon-download is-medium is-left-side"></span>-->
          <!--                <span>{{ $t("full_technical_sheet") }}</span>-->

          <!--            </sheet-block-associated-documents-item>-->
          <button class="button is-primary is-rounded is-uppercase ml-0" :class="brandBackgroundColor"
                  @click="selectModal()">
            <span class="icon-download is-medium is-left-side"></span>
            <span>{{ $t("full_technical_sheet") }}</span>
          </button>

          <button class="button is-primary is-rounded is-uppercase ml-0 button-share" :class="brandBackgroundColor"
                  @click="selectModal(true)" data-v-step='argument-10'>
            <span class="icon-share is-medium has-text-centered icon-right"></span>
          </button>

        </div>
      </div>
      <div class="extra-links" v-if="docType === 'machines' && productDatas.experience">
        <a class="site-block" data-mediabox="walkaround"
           :data-width="1000"
           :data-height="500"
           v-if="productDatas.experience.links['3d']"
           :href="productDatas.experience.links['3d']" target="_blank">
          <button class="rounded-button">
            <img :src="require(`@/assets/img/ar-red.svg`)" alt="AR Icon" class="icon">
            <span>{{ $t('augmented_reality') }}</span>
          </button>
        </a>
        <a class="site-block" data-mediabox="walkaround"
           :data-width="1000"
           :data-height="500"
           v-if="productDatas.experience.links['360ext']"
           :href="productDatas.experience.links['360ext']" target="_blank">
          <button class="rounded-button">
            <img :src="require(`@/assets/img/360ext-red.svg`)" alt="360 EXT Icon" class="icon">
            <span>{{ $t('360_ext') }}</span>
          </button>
        </a>
        <a class="site-block" data-mediabox="walkaround"
           :data-width="1000"
           :data-height="500"
           v-if="productDatas.experience.links['360int']"
           :href="productDatas.experience.links['360int']" target="_blank">
          <button class="rounded-button">
            <img :src="require(`@/assets/img/360int-red.svg`)" alt="360 INT Icon" class="icon">
            <span>{{ $t('360_int') }}</span>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
// import mediaService from '@/services/akeneo/media'
import sheetMixins from "@/common/mixins/sheet"
import {VIEW_URL} from "@/common/config";

import SheetBlockAssociatedDocumentsItem from "@/components/SheetBlock/SheetBlockAssociatedDocumentsItem";
import SheetBlockAssociatedDocumentsSelect from "@/components/SheetBlock/SheetBlockAssociatedDocumentsSelect";
import {localeToKebabCase, slugify, triggerTrackingEvent} from "@/common/helpers";

const defaultPicture = require('../../assets/img/no_image_available.jpg');
const loadingGif = require('../../assets/img/pix.png');

export default {
  name: 'OverviewPicture',
  mixins: [
    sheetMixins
  ],
  components: {
    SheetBlockAssociatedDocumentsItem, SheetBlockAssociatedDocumentsSelect,
  },
  props: {
    docType: {
      type: String,
      default: '',
    },
    family: {
      type: String,
      default: '',
      required: false
    },
    showARExperience: {
      type: Boolean,
      default: false,
      required: false
    },
    pictureDatas: {
      type: String,
    },
    hideDownload: {
      type: Boolean,
      default: false,
      required: false
    },
    btnRouteShowroom: {
      type: Object,
      required:false,
      default:null
    },
    btnRouteDocuments: {
      type: Object,
      required:false,
      default:null
    },
    experienceData: {
      type: Object,
      required: false,
      default: () => undefined
    }
  },
  data() {
    return {
      picture: defaultPicture,
      isComponentModalActive: false,
      showButtonDocuments: true,
      showButtonShowroom: false,
      mail: true,
      isLoadedPicture:false,
    }
  },
  watch: {
    pictureDatas: function () {
      this.picture = defaultPicture;
      this.fetchPicture();
    },

   //'$route.query.modal': {
   //  handler: function(modal) {
   //    if(modal) this.selectModal(true)
   //    this.$store.commit('vuetour/setVueTourOn', true);
   //  },
   //  deep: true,
   //  immediate: true
   //}
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      isPhone: state => state.settings.isPhone,
      unitType: state => state.settings.unitType,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    technicalNotice() {
      if (this.docType !== '') {
        return {
          identifier: 'technical',
          name: this.$t('full_technical_sheet'),
          link: `${VIEW_URL}/${this.docType}/${this.productDatas.identifier}?locale=${this.localeKebabFormat}&unit=${this.unitType}&format=pdf`,
          extension: 'pdf',
          filename: `${slugify(this.productDatas.name)}-technical-notice.pdf`,
          forceLinkDownload: true,
          product: this.productDatas,
        }
      } else return false;
    }
  },
  created() {
    this.fetchPicture();
  },
  methods: {
    loadImage() {
      this.isLoadedPicture = true;
    },
    fetchPicture() {
      //if (this.pictureDatas) {
      //    this.picture = loadingGif;
      //    this.startLoading();
      //    return mediaService
      //        .get(this.pictureDatas, {
      //            size: 'large'
      //        })
      //        .then(response => {
      //            if (response.data.code === 200)
      //                this.picture = response.data.data
      //            else
      //                this.picture = defaultPicture;
      //        })
      //        .finally(() => this.stopLoading());
      //}
      this.picture = this.pictureDatas
    },
    selectModal(mail = false) {
      this.$buefy.modal.open({
        parent: this,
        component: SheetBlockAssociatedDocumentsSelect,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        width: 700,
        props: {docType: this.docType, mail: mail}
      })

      // triggerTrackingEvent(mail ? 'open_technical_sheet_share_modal' : 'open_technical_sheet_download_modal', 'click', `Ouverture de la popin d'obtention de la fiche technique : ${this.productDatas.name} (${this.productDatas.identifier})`)
    }

  }
}
</script>

<style lang="scss">

.overview-picture-container {
  max-height: 500px;
}


.overview-picture {
  position: relative;
  text-align: center;
  padding-bottom: 60px;
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;

  &.loaded {
    aspect-ratio: auto;
  }
  @media #{$mq_phone} {
    padding-bottom: 40px;
  }

  &.no-buttons {
    padding-bottom: 0;
    @media #{$mq_phone} {
      padding-bottom: 0px;
    }

    .overview-image {
      margin: 0 auto;
      width: 100%;
    }
  }

  &.full-width {
    .overview-image {
      width: 100%;
      height: auto;
    }
  }

  &.centered {
    background-position: center;
  }

  .overview-image {
    max-width: 90%;
    max-height: 400px;
    margin: 20px auto;
  }

  .radial-gradient {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-image: radial-gradient(400px 400px at 0 0, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.19) 100%);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .link-container {
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    z-index: 2;
    text-align: center;

    &.has-ar-buttons {
      bottom: 84px;

      @media #{$mq_phone} {
        bottom: 100px;
      }
    }

    .buttons {
      display: inline-block;
      @media #{$mq_phone} {
        display: block;
      }
    }

    .button {
      margin: 10px 15px 0 15px;

      &.mr-0 {
        margin-right: 0;
        //padding-right:0
      }

      &.ml-0 {
        margin-left: 0;
        padding-right: 1.1rem;
      }
    }

    .button-share {
      border-left: solid 2px #ffffff
    }

  }

  .extra-links {
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
    z-index: 2;

    display: flex;
    justify-content: space-around;
    align-items: center;

    @media #{$mq_phone} {
      bottom: 25px;
      justify-content: center;
    }

    button {
      background: $white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 12px;
      margin: 0 10px;
      border-radius: 26px;

      @media #{$mq_phone_min} {
        flex: 1;
      }

      span {
        color: #101010;
        font-family: Roboto;
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 15px;
        margin-left: 5px;
        margin-right: 10px;

        @media #{$mq_phone} {
          display: none;
        }
      }

      .icon {
        margin-left: 10px;

        @media #{$mq_phone} {
          margin-left: 0;
        }
      }

    }
  }
  .icon-right{
    margin-right: 10px;
  }
}

.modal {
  z-index: 40000;
  width: auto;

  .animation-content {
    z-index: 1
  }
}
</style>
